import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'sledWood',
      d: 'M3.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h1.5v0.5h-1.5zM-3.5,-2h2.5v0.5h-2.5zM0.5,-2h0.5v0.5h-0.5zM-3.5,-1.5h1v1.5h-1zM-2,-1.5h1.5v0.5h-1.5zM-1.5,-1h1v2.5h-1z',
    },
    {
      paint: 'firewoodLog',
      d: 'M3,-3h1v0.5h-1zM2,-2.5h0.5v0.5h-0.5zM3.5,-2.5h0.5v1h-0.5zM1.5,-2h1v1h-1zM0,-1.5h0.5v1h-0.5zM3,-1.5h1v0.5h-1zM1.5,-1h2.5v0.5h-2.5zM0,-0.5h4v0.5h-4zM0,0h3v0.5h-3zM0,0.5h2v0.5h-2zM0,1h1v0.5h-1z',
    },
    {
      paint: 'roofB',
      d: 'M-2,-6h0.5v1h-0.5zM-2.5,-5h1v0.5h-1zM-3,-4.5h1v1h-1zM-1.5,-4.5h0.5v1h-0.5zM-3.5,-3.5h3v0.5h-3zM-3,-3h2.5v0.5h-2.5zM-2,-2.5h1.5v0.5h-1.5zM3,-2.5h0.5v1h-0.5zM-1,-2h1v0.5h-1zM1,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofA',
      d: 'M-1.5,-5.5h0.5v1h-0.5zM-1,-4.5h0.5v1h-0.5zM-0.5,-3.5h0.5v1.5h-0.5zM3,-3.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'snowCap',
      d: 'M1,-8.5h1.5v0.5h-1.5zM-0.5,-8h3v0.5h-3zM-1.5,-7.5h4v0.5h-4zM-2.5,-7h4v0.5h-4zM-2.5,-6.5h3v0.5h-3zM-3,-6h1v0.5h-1zM-1,-6h1v0.5h-1zM-3,-5.5h0.5v0.5h-0.5zM-3.5,-5h1v0.5h-1zM-3.5,-4.5h0.5v0.5h-0.5zM-4,-4h1v0.5h-1zM-3.5,0.5h1.5v0.5h-1.5zM-2.5,1h1v0.5h-1z',
    },
    {
      paint: 'ice',
      d: 'M1.5,-7h1.5v0.5h-1.5zM0.5,-6.5h3v0.5h-3zM-1.5,-6h0.5v0.5h-0.5zM0,-6h3.5v0.5h-3.5zM-1,-5.5h4.5v0.5h-4.5zM-0.5,-5h4.5v0.5h-4.5zM-0.5,-4.5h5v0.5h-5zM0,-4h4v0.5h-4zM0,-3.5h3v0.5h-3zM0,-3h2v0.5h-2zM0,-2.5h1v0.5h-1z',
    },
    { paint: 'bareBranch', d: 'M-0.5,-1.5h0.5v3.5h-0.5z' },
    {
      paint: 'wallShade',
      d: 'M2.5,-7.5h0.5v0.5h-0.5zM-2.5,-5.5h0.5v0.5h-0.5zM3.5,-5.5h0.5v0.5h-0.5zM-1,-5h0.5v0.5h-0.5zM-0.5,-4h0.5v0.5h-0.5zM4,-4h0.5v0.5h-0.5zM-4,-3.5h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM1,-2.5h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM-2.5,-1h1v1h-1zM-3.5,0h2v0.5h-2zM-2,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'lanternGlow', d: 'M-2,-4.5h0.5v1h-0.5zM2.5,-2.5h0.5v1.5h-0.5zM0.5,-1.5h1v1h-1z' },
  ],
  pixels: 254,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'sledWood',
      d: 'M3.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h1.5v0.5h-1.5zM-3.5,-2h2.5v0.5h-2.5zM0.5,-2h0.5v0.5h-0.5zM-3.5,-1.5h1v1.5h-1zM-2,-1.5h1.5v0.5h-1.5zM-1.5,-1h1v2.5h-1z',
    },
    {
      paint: 'firewoodLog',
      d: 'M3.5,-3h0.5v1.5h-0.5zM2,-2.5h0.5v1h-0.5zM1.5,-1.5h1v0.5h-1zM3,-1.5h1v0.5h-1zM0,-1h0.5v0.5h-0.5zM1.5,-1h2.5v0.5h-2.5zM0,-0.5h4v0.5h-4zM0,0h3v0.5h-3zM0,0.5h2v0.5h-2zM0,1h1v0.5h-1z',
    },
    { paint: 'wall', d: 'M3,-3h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5z' },
    {
      paint: 'roofB',
      d: 'M-2,-6h0.5v1h-0.5zM-2.5,-5h1v0.5h-1zM-3,-4.5h1v1h-1zM-1.5,-4.5h0.5v1h-0.5zM-3.5,-3.5h3v0.5h-3zM-3,-3h2.5v0.5h-2.5zM-2,-2.5h1.5v0.5h-1.5zM3,-2.5h0.5v1h-0.5zM-1,-2h1v0.5h-1zM1,-2h0.5v0.5h-0.5z',
    },
    { paint: 'roofA', d: 'M-1.5,-5.5h0.5v1h-0.5zM-1,-4.5h0.5v1h-0.5zM-0.5,-3.5h0.5v1.5h-0.5z' },
    {
      paint: 'snowCap',
      d: 'M1,-8.5h1.5v0.5h-1.5zM-0.5,-8h3v0.5h-3zM-1.5,-7.5h4v0.5h-4zM-2.5,-7h4v0.5h-4zM-2.5,-6.5h3v0.5h-3zM-3,-6h1v0.5h-1zM-1,-6h1v0.5h-1zM-3,-5.5h0.5v0.5h-0.5zM-3.5,-5h1v0.5h-1zM-3.5,-4.5h0.5v0.5h-0.5zM-4,-4h1v0.5h-1zM-3.5,0.5h1.5v0.5h-1.5zM-2.5,1h1v0.5h-1z',
    },
    {
      paint: 'ice',
      d: 'M1.5,-7h1.5v0.5h-1.5zM0.5,-6.5h3v0.5h-3zM-1.5,-6h0.5v0.5h-0.5zM0,-6h3.5v0.5h-3.5zM-1,-5.5h4.5v0.5h-4.5zM-0.5,-5h4.5v0.5h-4.5zM-0.5,-4.5h5v0.5h-5zM0,-4h4v0.5h-4zM0,-3.5h3v0.5h-3zM0,-3h2v0.5h-2zM0,-2.5h1v0.5h-1z',
    },
    { paint: 'bareBranch', d: 'M-0.5,-1.5h1v0.5h-1zM-0.5,-1h0.5v3h-0.5z' },
    {
      paint: 'wallShade',
      d: 'M2.5,-7.5h0.5v0.5h-0.5zM-2.5,-5.5h0.5v0.5h-0.5zM3.5,-5.5h0.5v0.5h-0.5zM-1,-5h0.5v0.5h-0.5zM-0.5,-4h0.5v0.5h-0.5zM4,-4h0.5v0.5h-0.5zM-4,-3.5h0.5v0.5h-0.5zM3,-3.5h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM1,-2.5h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM-2.5,-1h1v1h-1zM-3.5,0h2v0.5h-2zM-2,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'lanternGlow', d: 'M-2,-4.5h0.5v1h-0.5zM2.5,-2.5h0.5v1.5h-0.5zM0.5,-1.5h1v1h-1z' },
  ],
  pixels: 254,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'sledWood',
      d: 'M-3.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h1.5v0.5h-1.5zM-3.5,-2h2.5v0.5h-2.5zM-3.5,-1.5h1v1h-1zM-2,-1.5h1.5v0.5h-1.5zM-1.5,-1h1v2.5h-1zM-3,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'firewoodLog',
      d: 'M3.5,-2.5h0.5v1h-0.5zM2,-2h0.5v0.5h-0.5zM0,-1.5h0.5v1h-0.5zM1.5,-1.5h1v0.5h-1zM3,-1.5h1v0.5h-1zM1.5,-1h2.5v0.5h-2.5zM0,-0.5h4v0.5h-4zM0,0h3v0.5h-3zM0,0.5h2v0.5h-2zM0,1h1v0.5h-1z',
    },
    {
      paint: 'roofB',
      d: 'M-2,-6h0.5v1h-0.5zM-2.5,-5h1v0.5h-1zM-3,-4.5h1v1h-1zM-1.5,-4.5h0.5v1h-0.5zM-2,-3.5h1.5v0.5h-1.5zM-2.5,-3h2v0.5h-2zM-2,-2.5h1.5v0.5h-1.5zM3,-2.5h0.5v1h-0.5zM-1,-2h1v0.5h-1z',
    },
    { paint: 'roofA', d: 'M-1.5,-5.5h0.5v1h-0.5zM-1,-4.5h0.5v1h-0.5zM-0.5,-3.5h0.5v1.5h-0.5z' },
    {
      paint: 'snowCap',
      d: 'M1,-8.5h1.5v0.5h-1.5zM-0.5,-8h3v0.5h-3zM-1.5,-7.5h4v0.5h-4zM-2.5,-7h4v0.5h-4zM-2.5,-6.5h3v0.5h-3zM-3,-6h1v0.5h-1zM-1,-6h1v0.5h-1zM-3,-5.5h0.5v0.5h-0.5zM-3.5,-5h1v0.5h-1zM-3.5,-4.5h0.5v0.5h-0.5zM-4,-4h1v0.5h-1zM-4,-3.5h1.5v0.5h-1.5zM3,-3.5h1.5v0.5h-1.5zM2,-3h1.5v0.5h-1.5zM1,-2.5h1.5v0.5h-1.5zM0.5,-2h1v0.5h-1zM-4,-0.5h1v0.5h-1zM-4,0h1.5v0.5h-1.5zM-3.5,0.5h1.5v0.5h-1.5zM-2.5,1h1v0.5h-1z',
    },
    {
      paint: 'ice',
      d: 'M1.5,-7h1.5v0.5h-1.5zM0.5,-6.5h3v0.5h-3zM-1.5,-6h0.5v0.5h-0.5zM0,-6h3.5v0.5h-3.5zM-1,-5.5h4.5v0.5h-4.5zM-0.5,-5h4.5v0.5h-4.5zM-0.5,-4.5h5v0.5h-5zM0,-4h4v0.5h-4zM0,-3.5h3v0.5h-3zM0,-3h2v0.5h-2zM0,-2.5h1v0.5h-1z',
    },
    { paint: 'bareBranch', d: 'M-0.5,-1.5h0.5v3.5h-0.5z' },
    {
      paint: 'wallShade',
      d: 'M2.5,-7.5h0.5v0.5h-0.5zM-2.5,-5.5h0.5v0.5h-0.5zM3.5,-5.5h0.5v0.5h-0.5zM-1,-5h0.5v0.5h-0.5zM-0.5,-4h0.5v0.5h-0.5zM4,-4h0.5v0.5h-0.5zM-2.5,-3.5h0.5v0.5h-0.5zM-3,-3h0.5v0.5h-0.5zM3.5,-3h0.5v0.5h-0.5zM2.5,-2.5h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM0.5,-1.5h0.5v0.5h-0.5zM-2.5,-1h1v1.5h-1zM-2,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'lanternGlow',
      d: 'M-2,-4.5h0.5v1h-0.5zM2.5,-2h0.5v1h-0.5zM1,-1.5h0.5v0.5h-0.5zM0.5,-1h1v0.5h-1z',
    },
  ],
  pixels: 257,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
